import { v4 as uuidv4 } from "uuid";
import LatexRender from "../components/organisms/ai-tutor/LatexRender";
import { MathMLToLaTeX } from "mathml-to-latex";
import copy from "copy-to-clipboard";
import { isEmptyOrNull, isNotEmptyOrNull } from "./common-utils";
import { StorageService } from "./StorageUtils";

export const classifierInitialState = {
  classifierQuery: "",
  classifierText: "",
  classifierStatus: 3,
  classifierHistory: [],
};
export const summaryInitialState = {
  showSummary: false,
  summary: "",
  isSummaryCompleted: false,
};
export const DOUBT_TITLE = "Help me with a question";
export const PRACTICE_TITLE = "Give me practice problems";
export const LEARN_TITLE = "Please answer the below questions";

export const convertArrayWithSeperator = (text) => {
  if (Array.isArray(text)) {
    return text.join(", ");
  }

  return text;
};
export const handleRemoveExtraSpace = (str) => {
  return str
    ?.replace(/"'"/g, `'`)
    .replace(/(?<=\S) '/g, `'`)
    .replace(/ ,/g, ",")
    .replace(/\s(?=[^\w\s])/g, "");
};
export const AI_TUTOR = "Ai Tutor";
export const generateNewChatId = () => {
  const id = uuidv4();
  return id;
};
export const removeExtraTags = (name) => {
  return name?.replace("#*#*##*#*#", "")?.replace("#*#*#", "");
};
export const renderContent = (content = "") => {
  content = content?.toString();
  content = removeExtraTags(content);
  content = content?.replace(/\{\|c\|p\{\d+cm\}\|p\{\d+cm\}\|\}/g, "{|c|c|}");
  return (
    <div style={{ whiteSpace: "pre-line" }}>
      <LatexRender string={content} />
    </div>
  );
};

export const convertMarkdownToHtml = (content = "") => {
  try {
    // Convert headings
    content = content?.replace(/^### (.*$)/gim, "<h3>$1</h3>");
    content = content?.replace(/^## (.*$)/gim, "<h2>$1</h2>");
    content = content?.replace(/^# (.*$)/gim, "<h1>$1</h1>");
    // Convert bold text
    content = content?.replace(/\*\*(.*?)\*\*/gim, "<strong>$1</strong>");
    // Convert italic text
    content = content?.replace(/\*(.*?)\*/gim, "<em>$1</em>");
    // Convert unordered lists
    content = content?.replace(/^- (.*$)/gim, "<li>$1</li>");
    content = content?.replace(/(<li>.*<\/li>)/gim, "<ul>$1</ul>");

    // Convert underline text
    content = content.replace(/(?<=\s|^)__(\S.*?)__(?=\s|$)/gim, "<u>$1</u>");
  } catch (e) {
    console.log(e);
  }
  return content;
};
export const handleNavigateFeeback = (chatId) => {
  let URL = `${window?.ENV?.CHAT_VIEW_URL}/dashboard/tutor-feedback?chat_id=${chatId}&show_chat=true`;
  window.open(URL, "_blank");
};

export const OutOfContext = `Looks like the context of the conversation is changed,   Please select an option from below`;
export const OutOfTopic = `Looks like your question is outside the topic selected`;
export const EVENTS_LIST = {
  OTP_SENT: "OTP sent",
  OTP_VERIFIED: "OTP verified",
  TOPIC_CHANGED: "Topic selected or changed",
  SUMMARISE: "Conversation summarised",
  SEND_TO_POCKET: "Summary sent to pocket",
  USED_MATH_EDITOR: "Math editor used",
  CONTINUE_EXISTING_CONTEXT: "Continued existing context",
  FOLLOW_UP_QUESTION: "Clicked on Follow up question",
  SUMMARY_VIEW: "Summary viewed",
  CONVERSATION_VIEW: "User conversation viewed",
  VIDEO_VIEW: "Video viewed",
  IMAGE_VIEW: "Image viewed",
};

export const FeedbackVin = `Please give us feedback on the conversation that happened`;
export const feedback_initialstate = {
  outcome: "",
  outcome_division: "",
  outcome_reason: "",
  conversation_flow: "",
  conversation_reason: "",
  comment: "",
};

export const handleCopyClick = async (text) => {
  try {
    console.log("input text - ", text);
    copy(text);
    console.log("Text copied to clipboard", text);
  } catch (error) {
    console.log("Failed to copy: ", error);
  }
};
export const setCookie = (key, value) => {
  document.cookie = `${key}=${value}; path=/`;
};
export const getCookie = (name) => {
  const nameEQ = name + "=";
  if (typeof window !== "undefined") {
    const ca = document?.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const clearAllCookies = () => {
  if (typeof window !== "undefined") {
    const cookies = document?.cookie.split(";");

    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }
  }
};

export const tutorRoutes = [
  "/doubt",
  "/practice",
  "/ask-doubt",
  "/wall",
  "/wall-activity",
  "/wall-detailed-page",
  "/my-space",
  "/",
];

export const isMathML = (str) => {
  return str?.includes("http://www.w3.org/1998/Math/MathML");
};

export const mathMlToLatexEquation = (inputMath) => {
  if (isMathML(inputMath) && inputMath?.includes("<mfenced")) {
    //mathMlToLatexEquation
    const mathMLRegex = /<math(.*?)<\/math>/g;
    let mathMLMatches = [];
    let match;
    while ((match = mathMLRegex.exec(inputMath)) !== null) {
      mathMLMatches.push(match[0]);
    }
    mathMLMatches.forEach((mathML) => {
      const latexCode = MathMLToLaTeX.convert(mathML);
      let wrappedLatex = ` \\( ${latexCode} \\) `; // You can customize the LaTeX rendering here

      wrappedLatex = wrappedLatex?.replace(/\\left{/g, "\\left\\{");
      wrappedLatex = wrappedLatex?.replace(/\\left /g, "\\left.");
      wrappedLatex = wrappedLatex?.replace(/\\right}/g, "\\right\\}");
      wrappedLatex = wrappedLatex?.replace(/\\right /g, "\\right.");

      wrappedLatex = wrappedLatex?.replace(
        "\\left(\\begin{vmatrix}",
        "\\left.\\begin{vmatrix}"
      );
      wrappedLatex = wrappedLatex?.replace(
        "\\end{vmatrix}\\right)",
        "\\end{vmatrix}\\right."
      );
      wrappedLatex = wrappedLatex
        ?.replace(/\\left\(\\left\(\\right\./g, "(")
        ?.replace(/\\left\.\\right\)\\right\)/g, ")");

      wrappedLatex = wrappedLatex.replace(/\\&\\text\{nbsp\};/g, "");
      wrappedLatex = wrappedLatex.replace(/\\_{/g, "_{");

      // Replacing \\left(\\right. and \\left() with an empty string
      if (
        wrappedLatex?.includes("\\left(\\right.") &&
        wrappedLatex?.includes("\\left()")
      ) {
        wrappedLatex = wrappedLatex.replace(/\\left\(\s?\\right\.\s?/g, "");
        wrappedLatex = wrappedLatex.replace(/\\left\(\)/g, "");
      }

      //
      if (wrappedLatex?.includes("\\circ")) {
        wrappedLatex = wrappedLatex?.replace(/(?<!\^)\\circ/g, "^\\circ");
      }
      //
      if (wrappedLatex?.includes("^")) {
        if (/\^\{.*?\}/.test(wrappedLatex)) {
          wrappedLatex = wrappedLatex
            .replace(/\\left\(/g, "")
            .replace(/\\right\)/g, "");
        }
      }
      if (wrappedLatex?.includes("_")) {
        if (/\_\{.*?\}/.test(wrappedLatex)) {
          wrappedLatex = wrappedLatex
            .replace(/\\left\(/g, "")
            .replace(/\\right\)/g, "");
        }
      }
      inputMath = inputMath.replace(mathML, wrappedLatex);
    });
  }
  // console.log("inputMath.....", inputMath);
  return inputMath;
};

export const fetchGradeName = () => {
  let gradeName = "";
  try {
    let data = StorageService.getItem("user_additional_details");
    data = typeof data === "object" ? data : JSON.parse(data);
    //data = JSON.parse(data);
    gradeName = data?.grade_name?.split(" ")[1];
  } catch (e) {
    console.log(e);
  }
  return gradeName;
};

export const USER_UPDATE_MESSAGE = {
  success: "User details updated successfully !!",
  error: "Unable to update user !!",
};

export const getUserName = () => {
  if (typeof window !== "undefined") {
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    if (isNotEmptyOrNull(StorageService.getItem("name"))) {
      return StorageService.getItem("name");
    } else if (isNotEmptyOrNull(details)) {
      return details?.firstName;
    }
  }
  return "";
};

export const BOTTOM_BUTTONS = {
  contextSwitch: "Switch Context",
  stayHere: "Stay Here",
  hint: "I need a hint",
  conclude: "Conclude and help me with the answer",
  nextQuestion: "Next",
  feedback: "Feedback",
  endSession: "End Session",
  submit: "Submit",
  selectAnotherTopic: "Select another topic",
  continueConversation: "Continue conversation",
  endConversation: "End this conversation",
  anotherDoubt: "Ask another doubt",
  sendToPocket: "Send to pocket",
  tryAnotherQues: "Try Another Question",
  clarificationBtnText: "I need further clarification",
  gotit: "I got it",
  seeConversation: "See Conversation",
};

export const getConcludeBtnText = (level) => {
  const { conclude, gotit, endConversation } = BOTTOM_BUTTONS;
  switch (level) {
    case 0:
      return conclude;
    case 1:
      return gotit;
    default:
      return endConversation;
  }
};

export const handleExtractQuestionImages = (question) => {
  const { images_details = [], option_image_details } = question;
  const questionImages = images_details?.map((entry, index) => ({
    image_url: entry?.url,
    name: "Figure " + parseInt(index + 1),
  }));
  const optionImages = option_image_details?.map((entry, index) => ({
    image_url: entry?.url,
    name: "Option " + String.fromCharCode(65 + index),
  }));
  return [...(questionImages || []), ...(optionImages || [])];
};

export const handleExtractSolution = (question) => {
  const { solution_layout = [] } = question;
  const sampleAnsArr = [];
  solution_layout?.forEach((section) => {
    if (section && Array?.isArray(section?.data)) {
      section?.data?.forEach((item) => {
        if (item && !isEmptyOrNull(item?.text_layout)) {
          sampleAnsArr?.push(item?.text_layout);
        }
      });
    }
  });
  return sampleAnsArr?.join(',') || '';
}

export const handleExtractAnswerImages = (question) => {
  const { solution_layout, hintandexplanations, solutionsteps } = question;
  const extractMedia = (items) =>
    items?.flatMap((item) =>
      item?.data?.filter((entry) => !isEmptyOrNull(entry?.media))
    ) || [];

  //solution images
  const solutionImages = extractMedia(solution_layout || []);

  //explanation images
  const explanation = hintandexplanations?.[0]?.explanation || [];
  const explanationImages = extractMedia(explanation);

  //solution steps images
  const solutionSteps = solutionsteps?.[0]?.data || [];
  const solutionStepImages = extractMedia(solutionSteps);

  const combinedImages = [
    ...solutionImages,
    ...explanationImages,
    ...solutionStepImages,
  ];
  const answerImages = combinedImages
    ?.filter((item) => !isEmptyOrNull(item?.media))
    ?.map((entry, index) => ({
      image_url: entry?.media,
      name: `Image ${String?.fromCharCode(65 + index)}`, // 'A', 'B', 'B', etc.
    }));

  return answerImages;
};
export const ERROR_MESAGES = {
  BAD_REQUEST:
    "Sorry, an unexpected application error occurred. Please refresh the browser and try again.",
  SERVER_ERROR: "Unexpected server error. Please try again later.",
};
export const LOADING_MESSAGE = "Working on it. Please give me some more time";

export const HTTP_CODES = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  SERVER_ERROR: 500,
  GAATE_WAY_TIMEOUT: 504,
  UNAUTHORIZED: 401,
};
export const DOUBT = "Doubt";
export const PRACTICE = "Practice";
export const DESC_ANSWER = "Descriptive Answer";
export const IMAGE_TO_TEXT = "Image To Text";
export const TTS = "TTS";

const processHighlightedText = (text, subPart) => {
  if (isEmptyOrNull(subPart)) return text;
  const parts = text?.replace(subPart, `<b>${subPart}</b>`);
  return parts;
};

export const renderTextHighlight = (
  index,
  playingIndex,
  text,
  highlightText
) => {
  if (
    window?.ENV?.ENABLE_VOICE == "true" &&
    window?.ENV?.IS_TEXT_HILIGHT == "true"
  ) {
    return index == playingIndex
      ? processHighlightedText(text, highlightText)
      : text;
  } else {
    return text;
  }
};

export const splitTextAndLatex = (inputString) => {
  const regex =
    /(\\\(.*?\\\)|\\\[.*?\\\]|(?<!\$)\$(?!\$)(?:\\.|[^\$])*?\$(?!\$)|(?<!\$)\$\$(?:\\.|[^\$])*?\$\$(?!\$))/gs;
  let lastIndex = 0;
  const resultBlocks = [];

  inputString.replace(regex, (match, p1, offset) => {
    // Add text block if there's text before the LaTeX expression
    if (offset > lastIndex) {
      resultBlocks.push({
        index: uuidv4(),
        content: inputString.substring(lastIndex, offset),
      });
    }

    // Add LaTeX block
    resultBlocks.push({ index: uuidv4(), mathText: match, content: " " });

    // Update lastIndex to the end of the current match
    lastIndex = offset + match.length;
  });

  // Add any remaining text after the last LaTeX expression
  if (lastIndex < inputString.length) {
    resultBlocks.push({
      index: uuidv4(),
      content: inputString.substring(lastIndex),
    });
  }

  // Ensure the last item is of type "text"
  if (
    resultBlocks.length === 0 ||
    resultBlocks[resultBlocks.length - 1].type !== "text"
  ) {
    resultBlocks.push({
      index: uuidv4(),
      content: " ",
    });
  }

  return resultBlocks;
};

export const getCurriculumInfoByQuestion = (syllabusMapping) => {
  const { grade, subject, chapter } = syllabusMapping;
  return {
    grade: grade?.title,
    grade_id: grade?.id,
    subject: subject?.title,
    subject_id: subject?.id,
    topic_name: chapter?.title,
    topic_name_id: chapter?.id,
  };
};